import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import { MetricFormLinkEssentialsFragmentDoc } from '../../../../../../../../../../../fragments/__gen/index';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FieldDateRangeMetricQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  teamId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  isSuiteAdminDashboard?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type FieldDateRangeMetricQuery = { __typename: 'PharosQuery', fieldDateRangeMetric: { __typename: 'FieldDateRangeMetricType', id: string, name: string, values: Array<{ __typename: 'FieldDateValueType', content: string, contentObjectName: string, formLink: { __typename: 'MetricFormLink', formId: string, formTitle: string, recordId: string, recordName: string, fieldId: string | null, fieldTitle: string | null, organisationName: string, teamName: string } | null }> } | null };


export const FieldDateRangeMetricDocument = gql`
    query fieldDateRangeMetric($id: ID!, $teamId: ID, $isSuiteAdminDashboard: Boolean) {
  fieldDateRangeMetric(id: $id) {
    id
    name
    values(teamId: $teamId, isSuiteAdminDashboard: $isSuiteAdminDashboard) {
      content
      contentObjectName
      formLink {
        ...MetricFormLinkEssentials
      }
    }
  }
}
    ${MetricFormLinkEssentialsFragmentDoc}`;

/**
 * __useFieldDateRangeMetricQuery__
 *
 * To run a query within a React component, call `useFieldDateRangeMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldDateRangeMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldDateRangeMetricQuery({
 *   variables: {
 *      id: // value for 'id'
 *      teamId: // value for 'teamId'
 *      isSuiteAdminDashboard: // value for 'isSuiteAdminDashboard'
 *   },
 * });
 */
export function useFieldDateRangeMetricQuery(baseOptions: Apollo.QueryHookOptions<FieldDateRangeMetricQuery, FieldDateRangeMetricQueryVariables> & ({ variables: FieldDateRangeMetricQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FieldDateRangeMetricQuery, FieldDateRangeMetricQueryVariables>(FieldDateRangeMetricDocument, options);
      }
export function useFieldDateRangeMetricLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FieldDateRangeMetricQuery, FieldDateRangeMetricQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FieldDateRangeMetricQuery, FieldDateRangeMetricQueryVariables>(FieldDateRangeMetricDocument, options);
        }
export function useFieldDateRangeMetricSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FieldDateRangeMetricQuery, FieldDateRangeMetricQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FieldDateRangeMetricQuery, FieldDateRangeMetricQueryVariables>(FieldDateRangeMetricDocument, options);
        }
export type FieldDateRangeMetricQueryHookResult = ReturnType<typeof useFieldDateRangeMetricQuery>;
export type FieldDateRangeMetricLazyQueryHookResult = ReturnType<typeof useFieldDateRangeMetricLazyQuery>;
export type FieldDateRangeMetricSuspenseQueryHookResult = ReturnType<typeof useFieldDateRangeMetricSuspenseQuery>;
export type FieldDateRangeMetricQueryResult = Apollo.QueryResult<FieldDateRangeMetricQuery, FieldDateRangeMetricQueryVariables>;